import React from 'react';

import PopupConfirmCustomer from "../PopupConfirmCustomer";

export function ConfirmCustomerColumnFormatter(cellContent) {

  return (
    <PopupConfirmCustomer data={cellContent}/>
  );
}
